import React from 'react';
import TableAssessmentResetDialog from '../../components/dialogs/TableAssessmentResetDialog';

function ResultsPageDialogs(): React.JSX.Element {
    return <TableAssessmentResetDialog />;
}

export default ResultsPageDialogs;
